import { SdkResource } from './common';

export const dashboard = SdkResource.from((client) => ({
  getByDate: (fromDate: Date, toDate: Date) =>
    client
      .GET('/widgets/dashboard', {
        params: {
          query: {
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString(),
          },
        },
      })
      .then(({ data: response }) => response || []),
}));
